export const SavingType = {
	UPDATE: "UPDATE",
	CREATE: "CREATE"
}
